module.exports = __webpack_public_path__ + "static/media/6-4.ac13d7df.png";